import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { useStatusFilter } from "./useStatusFilter";
import { useAreaFilter } from "./useAreaFilter";
import { ALERTS_ID, useAlertsFilter } from "./useAlertsFilter";
import { useSortByFilter } from "./useSortByFilter";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useEdsDatesFilter } from "./useEdsDatesFilter";
import { useArticleHfbFilter } from "./useArticleHfbFilter";

export function useMediaOverviewFilters(areas: string[], edsDates: string[]) {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.MEDIA_OVERVIEW_FILTERS
  );

  const edsDateOptions = edsDates.map((edsDate) => {
    return {
      value: edsDate,
      title: edsDate,
      dependsOnFilterId: ALERTS_ID,
    };
  });

  const useMediaOverviewFilters = (filterValues: FilterValue[]) => [
    useStatusFilter(),
    useAreaFilter(areas),
    useArticleHfbFilter(),
    useAlertsFilter(),
    useEdsDatesFilter(filterValues, edsDateOptions),
    useSortByFilter(filterValues),
  ];

  return {
    useFiltersFactory: useMediaOverviewFilters,
    filterValues,
    setFilterValues,
  };
}
